import {
    Message
} from 'element-ui';
import crypto from 'crypto-js';
import {
    getToken,
    getUserInfo,
    removeAll
} from './cookie'
export default {

    DES_KEY: 'wxkn_2022',

    Message: function(type, content) {
        Message({
            message: content,
            type: type,
            showClose: true,
        })
    },

    axiosDicFun: function(that, url, params, responseType) {
        // get token
        let token = getToken()
        return new Promise(function(reslove, reject) {
            that.Axios({
                url: url,
                method: "post",
                params: params,
                headers: {
                    'contentType': 'application/x-www-form-urlencoded',
                    'X-Access-Token': token || ''
                },
                responseType: 'json'
            }).then((res) => {
                // console.log('当前请求接口', url);
                // console.log('当前请求接口url', url, "########请求数据", params, "***********返回数据data", res.data);
                if (res.data.code == 200) {
                    // 正常返回
                    // removeAll()
                    reslove(res.data.result)

                } else if (res.data.code == 401) {
                    that.$notify({
                        title: '错误',
                        message: '登录验证已过期，请重新登录',
                        type: 'error'
                    });
                    // token 过期失效
                    that.$router.push({
                            path: '/'
                        })
                        // 清除cookie
                    removeAll()
                        // 清除store
                    that.$store.commit('SET_HEADER_ACTIVE_INDEX');
                    that.$store.commit('SET_TOKEN');
                    that.$store.commit('SET_NAME');
                    that.$store.commit('SET_USER_ID');
                    that.$store.commit('SET_GROUP_ID');
                    that.$store.commit('SET_USER');
                } else if (res.headers['content-type'] === 'application/vnd.ms-excel') {
                    reslove(res);
                } else {
                    reject(res)
                }
            }).catch((err) => {
                // 捕捉执行异常
                console.log(err);
            })
        })
    },
    // axios 统一处理
    axiosFun: function(that, url, params, contentType, responseType) {
        // get token
        let token = getToken()
        return new Promise(function(reslove, reject) {
            that.Axios({
                url: url,
                method: "post",
                data: params,
                headers: {
                    'content-type': contentType || 'application/json;charset=utf-8',
                    'X-Access-Token': token || ''
                },
            }).then((res) => {
                // console.log('当前请求接口', url);
                // console.log('当前请求接口url', url, "########请求数据", params, "***********返回数据data", res.data);
                if (res.data.code == 200) {
                    // 正常返回
                    // removeAll()
                    reslove(res.data.result)

                } else if (res.data.code == 401) {
                    that.$notify({
                        title: '错误',
                        message: '登录验证已过期，请重新登录',
                        type: 'error'
                    });
                    // token 过期失效
                    that.$router.push({
                            path: '/'
                        })
                        // 清除cookie
                    removeAll()
                        // 清除store
                    that.$store.commit('SET_HEADER_ACTIVE_INDEX');
                    that.$store.commit('SET_TOKEN');
                    that.$store.commit('SET_NAME');
                    that.$store.commit('SET_USER_ID');
                    that.$store.commit('SET_GROUP_ID');
                    that.$store.commit('SET_USER');
                } else if (res.headers['content-type'] === 'application/vnd.ms-excel') {
                    that.$notify({
                        title: '错误',
                        message: res.message,
                        type: 'error'
                    });
                    reslove(res);
                } else {
                    that.$notify({
                        title: '错误',
                        message: res.message,
                        type: 'error'
                    });
                    reject(res)
                }
            }).catch((err) => {
                that.$notify({
                    title: '错误',
                    message: res.message,
                    type: 'error'
                });
                // 捕捉执行异常
                console.log(err);
            })
        })
    },
    getTime: function(date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    },
    switchTimeFormat(time) {
        function addZero(v) {
            return v < 10 ? '0' + v : v
        }
        const dateTime = new Date(time);
        const year = dateTime.getFullYear();
        const month = dateTime.getMonth() + 1;
        const date = dateTime.getDate();
        const hour = dateTime.getHours();
        const minute = dateTime.getMinutes();
        const second = dateTime.getSeconds();
        return `${year}-${addZero(month)}-${addZero(date)} ${addZero(hour)}:${addZero(minute)}:${addZero(second)}`;
        // return year + '-' + addZero(month) + '-' + addZero(date) + ' ' + addZero(hour) + ':' + addZero(minute) + ':' + addZero(second);
    },
    reduce: function(arr) {
        let sequence = Promise.resolve();
        arr.forEach(function(item) {
            sequence = sequence.then(item)
        });
        return sequence
    },
    judgeBrowser: function(val) {
        let Sys = {};
        let ua = val.toLowerCase();
        let s;
        (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1]:
            (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
            (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
            (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
        let browser;
        if (Sys.ie) {
            browser = 'ie (' + Sys.ie + ')';
        } else if (Sys.firefox) {
            browser = 'firefox (' + Sys.firefox + ')';
        } else if (Sys.chrome) {
            browser = 'chrome (' + Sys.chrome + ')';
        } else if (Sys.opera) {
            browser = 'opera (' + Sys.opera + ')';
        } else if (Sys.safari) {
            browser = 'safari (' + Sys.safari + ')';
        }
        return browser;
    },
    // 获取当前日期（年-月-日）
    nowDate: function() {
        var date1 = new Date(),
            time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate(); //time1表示当前时间
        return time1;
    },
    /*
     **获取几天前或几天后的日期（年-月-日）
     **day:number 正数表示几天后，负数表示几天前
     */
    targetDate(day) {
        var date1 = new Date(),
            time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate(); //time1表示当前时间
        var date2 = new Date(date1);
        date2.setDate(date1.getDate() + day);
        var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
        return time2
    },
    checkPhoneNum(num) {
        var regExp = new RegExp("^1[0-9]\\d{9}$")
        return regExp.test(num)
    },
    computeSignature(accessKeySecret, canonicalString) {
        return crypto.enc.Base64.stringify(crypto.HmacSHA1(canonicalString, accessKeySecret));
    }

}


// WEBPACK FOOTER //
// ./src/util/util.js